import React, { useEffect, useState } from "react";
import { getFetcher, postFetcher } from "../../../api/fetchers";
import { endpoints } from "../../../api/endpoints";
import "swiper/css/navigation";
import "swiper/css";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { GoChevronRight, GoChevronLeft } from "react-icons/go";
import shoppGroup from "../../assets/images/shoppgroup.png";
import { toast } from "react-toastify";
import shoppOk from "../../assets/images/shoopOk.png";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { parseStatics } from "../../function/parseStatics";
import { calculateDiscountedPrice } from "../../utils/functions";
import { Tooltip } from "flowbite-react";
import { useLanguage } from "../../context/LanguageContext";
import { useCurrency } from "../../context/CurrencyContext";

const getRandomUniqueElements = (arr: any[], count: number) => {
  const shuffled = [...arr].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

const Discount: React.FC = () => {
  const { t } = useLanguage();
  const { exchangeRate, currencySymbol } = useCurrency();
  const [products, setProducts] = useState<any>([]);
  const [dailyCampains, setDailyCampaigns] = useState<any>();
  // const [isBasket, setIsBasket] = useState(false);
  const [userBusinessPackage, setUserBusinessPackage] = useState<any>();
  const { user } = useUser();
  const [retailStatus] = useState(localStorage.getItem('rst') == "6535" ? true : false);
  const navigate = useNavigate();

  // const calculateOriginalPrice = (product: any) => {
  //   const discountPercentage = product?.discount;
  //   const discountedPrice = product?.price;
  //   if (discountPercentage && discountedPrice) {
  //     const originalPrice = discountedPrice / (1 - discountPercentage / 100);

  //     return originalPrice.toFixed(2);
  //   }

  //   return null;
  // };

  useEffect(() => {
    const getAllProducts = async () => {
      try {
        const response = await getFetcher(endpoints.products?.getAllProducts);

        if (response?.result) {
          setProducts(response.products);
        } else {
          setProducts([]);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getAllProducts();
  }, []);

  useEffect(() => {
    if (products.length > 0) {
      const dailyCampaignsSelection = getRandomUniqueElements(products, 8);
      setDailyCampaigns(dailyCampaignsSelection);
    }
  }, [products]);

  const handleClickAddToBasket = async (daily: any) => {
    // @ts-ignore
    const localUserId = parseStatics(localStorage.getItem("defaultUserId"));
    let userId;

    if (user) {
      userId = user.id;
    } else if (localStorage.getItem("defaultUserId")) {
      userId = localUserId;
    } else {
      userId = "";
    }

    try {
      const response = await postFetcher(endpoints.user.addProductBasket, {
        arg: {
          userId,
          productId: daily?.id,
          quantity: Number(1),
          attributes: {},
          bulkDiscount: 0,
          businessPackageId: user ? user.businessPackageId : "10",
        },
      });

      if (!localUserId && !user) {
        localStorage.setItem("defaultUserId", response.basketItem.userId);
      }

      if (response?.result) {
        toast.success(`${daily?.name} ${t('toastMessage', 'addBasketCartSuc')}`);
        //@ts-ignore
        const currentBasket: any = parseStatics(localStorage.getItem("basketItems")) || [];
        const updatedBasket: any = [...currentBasket, daily?.id];
        localStorage.setItem("basketItems", JSON.stringify(updatedBasket));
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        toast.error(t('toastMessage', 'addBasketCartErr'));
      }
    } catch (error) {
      console.error("Error adding product to basket:", error);
      toast.error(t('toastMessage', 'addBasketCartErr'));
    }
  };

  const handleSelectAttributes = () => {
    toast.warning(
      t('toastMessage', 'addBasketCartWarn')
    );
  };

  const fetchBusinessPackageData = async () => {
    if (user) {
      try {
        const businessPackage = await getFetcher(
          endpoints.user.getBusinessPackageById.replace(
            "{id}",
            user.businessPackageId
          )
        );
        if (businessPackage.result) {
          setUserBusinessPackage(businessPackage.businessPackage);
        }
      } catch (error) {
        console.error("Error fetching favorites:", error);
      }
    }
  };
  useEffect(() => {
    fetchBusinessPackageData();
  }, []);

  return (
    <div className="flex justify-center gap-y-1 flex-col items-start bg-white shadow-custom-shadow rounded-[19px] w-full lg:w-10/12 mx-auto z-20 py-1 xl:py-4 px-10 sm:mt-0  lg:-mt-3 xl:-mt-32  2xl:-mt-28 mb-5 transition-all">
      <div>
        <h2 className="text-[#141C3A] font-poppins font-semibold text-[22px] pt-2">
          {t("mainSlider", "discount")}
        </h2>
      </div>
      <div className="min-w-[300px] lg:min-w-[500px] max-w-full relative">
        {/* Navigation Buttons */}
        <div className="absolute top-1/2 -translate-y-1/2 -left-10 cursor-pointer z-10 swiper-button-prev-daily">
          <GoChevronLeft className="text-3xl text-gray-600 hover:text-black" />
        </div>
        <div className="absolute top-1/2 -translate-y-1/2 -right-10 cursor-pointer z-10 swiper-button-next-daily">
          <GoChevronRight className="text-3xl text-gray-600 hover:text-black" />
        </div>

        <Swiper
          modules={[Navigation]}
          navigation={{
            nextEl: ".swiper-button-next-daily",
            prevEl: ".swiper-button-prev-daily",
          }}
          spaceBetween={40}
          slidesPerView="auto"
          centeredSlides={false}
        >
          {dailyCampains?.map((daily: any, index: number) => (
            <SwiperSlide
              key={index}
              className=" !w-[170px] md:!w-[250px] lg:!w-[315px] flex-shrink-0 py-5"
            >
              {/* Card Container */}
              <div className="bg-[#F7F7F7] h-full border md:h-[140px] select-none lg:h-[165px] mx-auto rounded-[7px] shadow-[#00000040] shadow-md hover:bg-gradient-to-b hover:from-[#FFE053] hover:to-[#FFD102]">
                <div className="flex gap-x-2 h-full flex-col md:flex-row">
                  <div className=" flex-[1.5] lg:flex-[1.75] h-[140px] my-auto py-2 px-1 object-contain">
                    <img
                      className="h-full w-full object-contain p-1 rounded-lg cursor-pointer max-h-[120px] md:max-h-full max-w-[90px] md:max-w-full mx-auto min-w-[60px]"
                      src={daily?.images[0]}
                      alt="..."
                      onClick={() => navigate(`/product-detail/${daily?.id}`)}
                    />
                  </div>
                  <div className="flex-[2] flex flex-col justify-between p-3">
                    <div
                      className="min-h-[80px] cursor-pointer"
                      onClick={() => navigate(`/product-detail/${daily?.id}`)}
                    >
                      <p className="text-[#808080] text-[7px] lg:text-[10px] opacity-[70%] font-rubik font-normal">
                        {daily?.brand}
                      </p>
                      <p className="text-primary-color text-[13px] lg:text-[16px] font-rubik font-[500]">
                        {daily?.name?.length > 20 ? (
                          <Tooltip content={daily?.name} style="light">
                            {daily?.name.slice(0, 20)}...
                          </Tooltip>
                        ) : (
                          daily?.name
                        )}
                      </p>
                    </div>
                    {
                      retailStatus ?
                        <div className="flex justify-between items-center mt-auto">
                          {/* add basket */}
                          {Object.keys(daily?.attributes || {}).length < 1 ? (
                            <div
                              onClick={() => handleClickAddToBasket(daily)}
                              className="rounded-r-lg rounded-b-none rounded-l-none p-2 transition-all group-hover:bg-transparent group-hover:rounded-bl-lg"
                            >
                              {(() => {
                                const basketItems: any[] = parseStatics(
                                  localStorage.getItem("basketItems") || "[]"
                                );

                                if (basketItems.includes(daily?.id)) {
                                  return (
                                    <img
                                      className="w-12 cursor-pointer"
                                      src={shoppOk}
                                      alt="shoppingIcon"
                                    />
                                  );
                                }

                                return (
                                  <img
                                    className="cursor-pointer"
                                    src={shoppGroup}
                                    alt="shoppingIcon"
                                  />
                                );
                              })()}
                            </div>
                          ) : (
                            <div
                              onClick={handleSelectAttributes}
                              className="rounded-r-lg rounded-b-none rounded-l-none p-2 transition-all group-hover:bg-transparent group-hover:rounded-bl-lg"
                            >
                              <img
                                src={shoppGroup}
                                alt="shoppingIcon"
                                className="cursor-pointer w-full h-full min-w-10"
                              />
                            </div>
                          )}
                          {/* price */}
                          <div className=" flex w-full justify-end font-bold flex-col items-end ">
                            {daily?.discount ||
                              (userBusinessPackage &&
                                userBusinessPackage?.id !== "10") ? (
                              <span className="line-through text-red-900 text-sm font-rubik font-normal">
                                {/* {daily?.price}TL */}
                                {currencySymbol}
                                {(daily?.price * exchangeRate).toFixed(2)}
                              </span>
                            ) : null}
                            <div className=" text-[19px] text-[#141C3A] ">
                              {daily?.discount ||
                                (userBusinessPackage &&
                                  userBusinessPackage?.id !== "10") ? (
                                <span>
                                  {/* {calculateDiscountedPrice(
                                daily?.price,
                                daily?.discount,
                                userBusinessPackage
                                  ? userBusinessPackage?.ratio
                                  : 0
                              )}
                              TL */}
                                  {currencySymbol}
                                  {(
                                    calculateDiscountedPrice(
                                      daily.price,
                                      daily.discount,
                                      userBusinessPackage ? userBusinessPackage?.ratio : 0, exchangeRate
                                    )
                                  ).toFixed(2)}
                                </span>
                              ) : (
                                <span className={`flex items-end h-[50px]`}>
                                  {/* {daily?.price}TL */}
                                  {currencySymbol}
                                  {(
                                    calculateDiscountedPrice(
                                      daily.price,
                                      daily.discount,
                                      userBusinessPackage ? userBusinessPackage?.ratio : 0, exchangeRate
                                    )
                                  ).toFixed(2)}
                                </span>
                              )}
                            </div>
                          </div>

                          {/* <div className="text-right">
                        {daily?.discount ? (
                          <span className="line-through text-[#808080] text-xs lg:text-sm font-rubik font-normal">
                            {calculateOriginalPrice(daily)}TL
                          </span>
                        ) : null}
                        <span className=" text-[20px] lg:text-[22px] text-[#141C3A] font-rubik font-[500] block">
                          {daily?.price}TL
                        </span>
                      </div> */}
                        </div>
                        :
                        <div className="flex justify-between items-center mt-auto">
                          <p className="text-xs">{daily?.description?.substring(0,50)}..</p>
                        </div>
                    }
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Discount;
